import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";


import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";

import cyber2 from "assets/img/cyber2.jpg";


import ev3 from "assets/img/EV3.jpg";
import ev4 from "assets/img/EV4.jpg";

import ilbc from "assets/img/ilbc.jpg";
import ilbc1 from "assets/img/ilbc1.jpg";


import uit4 from "assets/img/uit4.jpg";
import loihein from "assets/img/loihein.jpg";
class SectionCarousel extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,

    };
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
              <Card carousel>
                <Carousel {...settings}>
              <div>
                    <img
                      src={ilbc}
                      alt="ILBC"
                      className="slick-image"
                    />
                   <div>
                   <h4 className={classes.text}>
                   
                   <LocationOn/>ILBC
                  
                   </h4>
                   </div>

                  </div>
                 
                   <div>
                    <img
                      src={ilbc1}
                      alt="ILBC"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                          <LocationOn/>ILBC
                      </h4>
                    </div>
                  </div>

                  <div>
                    <img
                      src={ev3}
                      alt="EV"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                        <LocationOn />EV Association Preparation in Myanmar
                      </h4>
                    </div>
                  </div>
                  <div>
                    <img
                      src={ev4}
                      alt="EV"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                        <LocationOn/>EV Association Preparation in Myanmar
                      </h4>
                    </div>
                  </div>

                  <div>
                    <img
                      src={cyber2}
                      alt="Cyber Security Presentation with Pwc"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                        <LocationOn/>Cyber Security Presentation with Pwc
                      </h4>
                    </div>
                  </div>
                   
                  
                  

                  <div>
                    <img
                      src={uit4}
                      alt="UIT IoT Lab"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                        <LocationOn/>UIT IoT Lab
                      </h4>
                    </div>
                  </div>
                   <div>
                    <img
                      src={loihein}
                      alt="LoiHein Factory"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                        <LocationOn />LoiHein Factory 
                      </h4>
                    </div>
                  </div>
                 

                </Carousel>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(carouselStyle)(SectionCarousel);



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionCarousel.jsx